import { FieldValues, useController } from "react-hook-form";
import Control from "../control";
import DependantTrigger from "./components/dependantTrigger";
import ParentTrigger from "./components/parentTrigger";
import { SelectWrapper } from "./components/select";
import { FormControlProps } from "./types";
import { pathToArray } from "./utils";

export default function FormControl<TFieldValues extends FieldValues>(
  props: Readonly<FormControlProps<TFieldValues>>,
) {
  const { name } = props;
  const {
    disabledValidation,
    helperText,
    dependantControlNames,
    parentControlNames,
    interceptValue,
    interceptChange,
    onChange: propsOnChange,
    onBlur: propsOnBlur,
    ...rest
  } = props;

  const {
    field: { value, onChange, onBlur, ref },
    fieldState: { error },
  } = useController<TFieldValues>({ name: name });

  const parsedValue = interceptValue ? interceptValue(value) : value;

  const handleChange = (value: any) => {
    const parsedValue = interceptChange ? interceptChange(value) : value;
    onChange(parsedValue ?? null);
    propsOnChange?.(parsedValue ?? null);
  };

  const handleBlur = () => {
    onBlur();
    propsOnBlur?.();
  };

  const dependants = pathToArray(dependantControlNames);
  const parents = pathToArray(parentControlNames);

  let component = (
    <Control
      {...rest}
      value={parsedValue}
      helperText={
        !disabledValidation && !!error?.message ? error.message : helperText
      }
      error={!disabledValidation && !!error?.message}
      getInputRef={ref}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );

  if (props.type === "select" && parents?.length) {
    component = (
      <SelectWrapper
        name={name}
        options={props.options}
        parentControlNames={parentControlNames}
      >
        {component}
      </SelectWrapper>
    );
  }

  return (
    <>
      {!!dependants?.length && (
        <DependantTrigger value={parsedValue} controls={dependants} />
      )}
      {!!parents?.length && <ParentTrigger name={name} controls={parents} />}
      {component}
    </>
  );
}
